import { instanceOEF, instanceApi, instancePromotionApi } from './api'

export const getPlanoPorModalidade = modalidadeParaPlano => instanceApi.get( `v1/planos?modalidade=${modalidadeParaPlano}` )

export const getDescontoClubesAPI = ( { idAssinatura, idPlano } ) => {
  if ( idAssinatura ) {
    return instancePromotionApi.get( `/pre-process?subscription_id=${idAssinatura}&plan_id=${idPlano}` )
  }
  return instancePromotionApi.get( `/pre-process?plan_id=${idPlano}` )
}

export const escolherPlano = ( { idVenda, idPlano } ) => {
  const body = {
    'plano_id': idPlano,
    'venda_id': idVenda,
  }
  return instanceOEF.post( `/v2/venda/escolhe-plano`, body )
}
